import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Austin Andrews
 * id A975CEEA-FDFD-49A2-A618-E74A3FF87A63
 * name account-settings
 * version: 1.6.50
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/account-settings.svg
 * tags
 * - Account / User 
 * - Settings 
 */
export const AccountSettingsIcon = createSvgIcon(<><path d="M12,4A4,4 0 0,1 16,8A4,4 0 0,1 12,12A4,4 0 0,1 8,8A4,4 0 0,1 12,4M12,14C16.42,14 20,15.79 20,18V20H4V18C4,15.79 7.58,14 12,14M7,22H9V24H7V22M11,22H13V24H11V22M15,22H17V24H15V22Z" /></>, 'AccountSettingsIcon');
export default AccountSettingsIcon